import { TenantSwitchingState, initialTenantSwitchingState } from "./tenant-switching.state";
import { TenantSwitchingActions, TenantSwitchingActionType } from "./tenant-switching.actions";

export function tenantSwitchingReducer(
  state: TenantSwitchingState = initialTenantSwitchingState,
  action: TenantSwitchingActions
): TenantSwitchingState {
  switch (action.type) {
    case TenantSwitchingActionType.SET_AVAILABLE_TENANTS:
      return {
        ...state,
        availableTenants: action.payload,
        error: null
      };

    case TenantSwitchingActionType.SET_SELECTED_TENANT:
      return {
        ...state,
        selectedTenantId: action.payload
      };

    case TenantSwitchingActionType.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case TenantSwitchingActionType.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        isSwitching: false
      };

    case TenantSwitchingActionType.CLEAR_ERROR:
      return {
        ...state,
        error: null
      };

    case TenantSwitchingActionType.SET_SWITCHING:
      return {
        ...state,
        isSwitching: action.payload
      };

    case TenantSwitchingActionType.CLEAR_TENANTS:
      return {
        ...initialTenantSwitchingState
      };

    default:
      return state;
  }
}
